// config/deviceFeatures.js

// ============================================================
// 1. 统一权限树
// ============================================================
export const PERMISSION_TREE = [
  // ===== 销售台账 =====
  {
    label: '📋 销售台账',
    value: 'sale',
    children: [
      { label: '👁️ 查看销售台账', value: 'sale_view', desktop: true, mobile: true },
      { label: '📊 销售汇总', value: 'sale_summary', desktop: true, mobile: true },
      { label: '👤 查看客户', value: 'sale_view_customer', desktop: true, mobile: true },
      { label: '📅 添加日期', value: 'sale_add_date', desktop: true, mobile: false },
      { label: '📁 添加款式', value: 'sale_add_style', desktop: true, mobile: false },
      { label: '📏 添加尺码', value: 'sale_add_size', desktop: true, mobile: false },
      { label: '📥 导入', value: 'sale_import', desktop: true, mobile: false },
      { label: '📥 同步生产数据', value: 'sale_import_from_production', desktop: true, mobile: false },   // ✅ 新增
      { label: '💾 保存', value: 'sale_save', desktop: true, mobile: false },
      { label: '✏️ 编辑尺码', value: 'sale_edit_size', desktop: true, mobile: false },
      { label: '🗑️ 删除行', value: 'sale_delete_row', desktop: true, mobile: false },
      { label: '🗑️ 批量删除', value: 'sale_batch_delete', desktop: true, mobile: false },
      { label: '💰 结算', value: 'sale_settle', desktop: true, mobile: true },
      { label: '📷 截图', value: 'sale_screenshot', desktop: true, mobile: false },
      { label: '🎨 颜色分组', value: 'sale_toggle_color', desktop: true, mobile: false },
    ],
  },

  // ===== 生产台账 =====
  {
    label: '🏭 生产台账',
    value: 'production',
    children: [
      { label: '👁️ 查看生产台账', value: 'production_view', desktop: true, mobile: true },
      { label: '📊 生产汇总', value: 'production_summary', desktop: true, mobile: true },
      { label: '📊 数据分析', value: 'production_analysis', desktop: true, mobile: true },   // ✅ 新增
      { label: '💰 查看总成本', value: 'production_view_total_cost', desktop: true, mobile: true },
      { label: '📅 添加日期', value: 'production_add_date', desktop: true, mobile: false },
      { label: '📁 添加款式', value: 'production_add_style', desktop: true, mobile: false },
      { label: '📏 添加尺码', value: 'production_add_size', desktop: true, mobile: false },
      { label: '✏️ 编辑尺码', value: 'production_edit_size', desktop: true, mobile: false },
      { label: '📋 编辑单号', value: 'production_edit_order_number', desktop: true, mobile: false },
      { label: '🏢 编辑客户', value: 'production_edit_customer', desktop: true, mobile: false },
      { label: '🗑️ 删除行', value: 'production_delete_row', desktop: true, mobile: false },
      { label: '🗑️ 批量删除', value: 'production_batch_delete', desktop: true, mobile: false },
      { label: '📥 导入', value: 'production_import', desktop: true, mobile: false },
      { label: '💾 保存', value: 'production_save', desktop: true, mobile: false },
      { label: '👷 分配工人', value: 'production_assign_worker', desktop: true, mobile: false },
      { label: '🔄 更新状态', value: 'production_update_status', desktop: true, mobile: true },
      // ✅ 新增：生产结算
      { label: '💰 结算', value: 'production_settle', desktop: true, mobile: true },
      { label: '📷 截图', value: 'production_screenshot', desktop: true, mobile: false },
      { label: '🎨 颜色分组', value: 'production_toggle_color', desktop: true, mobile: false },
    ],
  },

  // ===== 记账管理 =====
  {
    label: '📒 记账管理',
    value: 'bookkeeping',
    children: [
      { label: '👁️ 查看记账', value: 'bookkeeping_view', desktop: true, mobile: true },
      { label: '📊 记账汇总', value: 'bookkeeping_summary', desktop: true, mobile: true },
      { label: '📅 添加日期', value: 'bookkeeping_add_date', desktop: true, mobile: false },
      { label: '📁 添加款式', value: 'bookkeeping_add_style', desktop: true, mobile: false },
      { label: '✏️ 编辑明细', value: 'bookkeeping_edit_entry', desktop: true, mobile: true },
      { label: '🗑️ 删除行', value: 'bookkeeping_delete_row', desktop: true, mobile: false },
      { label: '🗑️ 批量删除', value: 'bookkeeping_batch_delete', desktop: true, mobile: false },
      { label: '📷 截图', value: 'bookkeeping_screenshot', desktop: true, mobile: false },
      { label: '💰 结算', value: 'bookkeeping_settle', desktop: true, mobile: true },
    ],
  },

  // ===== 款式管理 =====
  {
    label: '📁 款式管理',
    value: 'style',
    children: [
      { label: '👁️ 查看款式', value: 'style_view', desktop: true, mobile: true },
      { label: '📁 新增款式', value: 'style_add', desktop: true, mobile: false },
      { label: '✏️ 编辑款式', value: 'style_edit', desktop: true, mobile: false },
      { label: '🗑️ 删除款式', value: 'style_delete', desktop: true, mobile: false },
      { label: '📂 分类管理', value: 'style_manage_category', desktop: true, mobile: false },
      { label: '🏷️ 生产类型', value: 'style_manage_production_type', desktop: true, mobile: false },
      { label: '⚙️ 工艺管理', value: 'style_manage_process', desktop: true, mobile: false },
    ],
  },

  // ===== 工艺管理 =====
  {
    label: '⚙️ 工艺管理',
    value: 'process',
    children: [
      { label: '👁️ 查看工艺', value: 'process_view', desktop: true, mobile: true },
      { label: '📁 新增工艺', value: 'process_add', desktop: true, mobile: false },
      { label: '✏️ 编辑工艺', value: 'process_edit', desktop: true, mobile: false },
      { label: '🗑️ 删除工艺', value: 'process_delete', desktop: true, mobile: false },
      { label: '🏷️ 类型管理', value: 'process_manage_type', desktop: true, mobile: false },
      { label: '🏢 供应商管理', value: 'process_manage_supplier', desktop: true, mobile: false },
    ],
  },

  // ===== 原料管理 =====
  {
    label: '🧵 原料管理',
    value: 'material',
    children: [
      { label: '👁️ 查看原料', value: 'material_view', desktop: true, mobile: true },
      { label: '📁 新增原料', value: 'material_add', desktop: true, mobile: false },
      { label: '✏️ 编辑原料', value: 'material_edit', desktop: true, mobile: false },
      { label: '🗑️ 删除原料', value: 'material_delete', desktop: true, mobile: false },
      { label: '🏢 供应商管理', value: 'material_manage_supplier', desktop: true, mobile: false },
      { label: '📂 分类管理', value: 'material_manage_category', desktop: true, mobile: false },
    ],
  },

  // ===== 客户管理 =====
  {
    label: '📋 客户管理',
    value: 'customer',
    children: [
      { label: '👁️ 查看客户', value: 'customer_view', desktop: true, mobile: true },
      { label: '📁 新增客户', value: 'customer_add', desktop: true, mobile: false },
      { label: '✏️ 编辑客户', value: 'customer_edit', desktop: true, mobile: false },
      { label: '🗑️ 删除客户', value: 'customer_delete', desktop: true, mobile: false },
    ],
  },

  // ===== 系统管理 =====
  {
    label: '⚙️ 系统管理',
    value: 'system',
    children: [
      { label: '👁️ 查看权限', value: 'system_view_permission', desktop: true, mobile: true },
      { label: '🔐 管理权限', value: 'system_manage_permission', desktop: true, mobile: false },
      { label: '🔄 切换模式', value: 'system_switch_mode', desktop: true, mobile: false },
      { label: '👤 用户管理', value: 'system_user_manage', desktop: true, mobile: false },
      { label: '🔑 修改密码', value: 'system_modify_password', desktop: true, mobile: true },
      { label: '🛒 销售平台', value: 'system_manage_platform', desktop: true, mobile: false },
      { label: '📂 恢复备份', value: 'system_restore_backup', desktop: true, mobile: false },
      { label: '💾 创建备份', value: 'system_create_backup', desktop: true, mobile: false },
      { label: '📷 截图', value: 'system_screenshot', desktop: true, mobile: false },
    ],
  },

  // ===== 筛选功能 =====
  {
    label: '🔍 筛选功能',
    value: 'filter',
    children: [
      { label: '📅 日期筛选', value: 'filter_date', desktop: true, mobile: true },
      { label: '📆 月份筛选', value: 'filter_month', desktop: true, mobile: true },
      { label: '👤 客户筛选', value: 'filter_customer', desktop: true, mobile: true },
      { label: '🔎 搜索筛选', value: 'filter_search', desktop: true, mobile: true },
      { label: '📁 款式筛选', value: 'filter_style', desktop: true, mobile: false },
      { label: '🏷️ 分类筛选', value: 'filter_category', desktop: true, mobile: false },
      { label: '🎨 颜色筛选', value: 'filter_color', desktop: true, mobile: false },
      { label: '📏 尺码筛选', value: 'filter_size', desktop: true, mobile: false },
      { label: '📊 状态筛选', value: 'filter_status', desktop: true, mobile: true },
      { label: '👷 生产人员筛选', value: 'filter_production_staff', desktop: true, mobile: false },
      { label: '📋 分配人员筛选', value: 'filter_assigned_staff', desktop: true, mobile: false },
      { label: '🏭 工艺筛选', value: 'filter_process', desktop: true, mobile: false },
      { label: '🏭 工艺类型筛选', value: 'filter_process_type', desktop: true, mobile: false },
      { label: '📦 原料分类筛选', value: 'filter_material_category', desktop: true, mobile: false },
      { label: '🏢 供应商筛选', value: 'filter_supplier', desktop: true, mobile: false },
      { label: '🎨 原料颜色筛选', value: 'filter_material_color', desktop: true, mobile: false },
      { label: '📋 客户状态筛选', value: 'filter_customer_status', desktop: true, mobile: false },
      { label: '🏷️ 销售平台筛选', value: 'filter_sales_platform', desktop: true, mobile: false },
      { label: '🔢 单号筛选', value: 'filter_order_number', desktop: true, mobile: true },
    ],
  },
]

// ============================================================
// 2. 自动生成 FEATURES
// ============================================================
export const FEATURES = (() => {
  const result = {}

  for (const parent of PERMISSION_TREE) {
    const module = parent.value

    if (!result[module]) result[module] = {}

    for (const child of parent.children) {
      result[module][child.value] = {
        desktop: child.desktop,
        mobile: child.mobile,
        _permission: child.value,
      }
    }
  }

  // ===== 添加 displayFields =====
  result.sale.displayFields = {
    desktop: ['category', 'price', 'subtotal', 'skc', 'platform', 'urgent', 'order_number'],
    mobile: ['price'],
  }

  result.production.displayFields = {
    desktop: ['category', 'price', 'worker', 'status', 'subtotal', 'total', 'skc', 'platform', 'urgent', 'order_number', 'assigned_by'],
    mobile: ['worker', 'status', 'assigned_by'],
  }

  // ✅ 记账显示字段
  result.bookkeeping.displayFields = {
    desktop: ['process', 'quantity', 'unit_price', 'subtotal', 'worker'],
    mobile: ['process', 'quantity', 'subtotal', 'worker'],
  }

  // ===== 添加 columns =====
  result.style.columns = {
    desktop: [
      { span: 1, key: 'index', align: 'center', label: '序号' },
      { span: 1, key: 'image', align: 'center', label: '图片' },
      { span: 4, key: 'name', align: 'left', label: '名称' },
      { span: 11, key: 'colors', align: 'center', label: '颜色' },
      { span: 2, key: 'category', align: 'center', label: '分类' },
      { span: 1, key: 'price', align: 'center', label: '销售价' },
      { span: 1, key: 'productionPrice', align: 'center', label: '成本价' },
      { span: 3, key: 'actions', align: 'center', label: '操作', justify: 'flex-end' },
    ],
    mobile: [
      { span: 20, key: 'name', label: '名称' },
      { span: 4, key: 'price', label: '销售价', justify: 'flex-end' },
      { key: 'colors', label: '颜色' },
    ],
  }

  result.process.columns = {
    desktop: [
      { span: 1, key: 'index', align: 'center', label: '序号' },
      { span: 8, key: 'name', align: 'left', label: '工艺名称' },
      { span: 4, key: 'shoeType', align: 'center', label: '类型' },
      // ❌ 已删除：适用部分 partType
      { span: 4, key: 'supplier', align: 'left', label: '供应商' },
      { span: 2, key: 'unit', align: 'center', label: '单位' },
      { span: 2, key: 'laborFee', align: 'center', label: '工费' },
      { span: 3, key: 'actions', align: 'center', label: '操作', justify: 'flex-end' },
    ],
    mobile: [
      { span: 14, key: 'name', label: '工艺名称' },
      { span: 5, key: 'shoeType', label: '类型' },
      { span: 5, key: 'laborFee', label: '工费' },
      { span: 24, key: 'supplier', label: '供应商' },
    ],
  }

  result.material.columns = {
    desktop: [
      { span: 1, key: 'index', align: 'center', label: '序号' },
      { span: 3, key: 'category', align: 'left', label: '分类' },
      { span: 5, key: 'name', align: 'left', label: '名称/型号' },
      { span: 4, key: 'colors', align: 'center', label: '颜色' },
      { span: 5, key: 'supplier', align: 'left', label: '供应商' },
      { span: 2, key: 'price', align: 'center', label: '单价' },
      { span: 1, key: 'unit', align: 'center', label: '单位' },
      { span: 3, key: 'actions', align: 'center', label: '操作', justify: 'flex-end' },
    ],
    mobile: [
      { span: 11, key: 'name', label: '名称' },
      { span: 4, key: 'category', label: '分类' },
      { span: 4, key: 'price', label: '单价' },
      { span: 5, key: 'supplier', label: '供应商' },
    ],
  }

  result.customer.columns = {
    desktop: [
      { span: 1, key: 'index', align: 'left', label: '序号' },
      { span: 4, key: 'name', align: 'left', label: '客户名称' },
      { span: 17, key: 'styles', align: 'left', label: '关联款式' },
      { span: 2, key: 'actions', align: 'center', label: '操作', justify: 'flex-end' },
    ],
    mobile: [
      { span: 24, key: 'name', label: '客户名称', justify: 'space-between' },
      { key: 'styles', label: '关联款式' },
    ],
  }

  result.system.columns = {
    desktop: [
      { span: 4, key: 'tab', align: 'left', label: '标签页' },
      { span: 16, key: 'content', align: 'left', label: '内容' },
      { span: 4, key: 'actions', align: 'center', label: '操作', justify: 'flex-end' },
    ],
    mobile: [
      { key: 'tab', label: '标签页' },
      { key: 'content', label: '内容' },
    ],
  }

  // ✅ 记账 columns
  result.bookkeeping.columns = {
    desktop: [
      { span: 1, key: 'index', align: 'center', label: '序号' },
      { span: 2, key: 'date', align: 'center', label: '日期' },
      { span: 2, key: 'style', align: 'left', label: '款式' },
      { span: 2, key: 'process', align: 'center', label: '工艺' },
      { span: 2, key: 'color', align: 'center', label: '颜色' },
      { span: 3, key: 'worker', align: 'center', label: '加工人' },
      { span: 10, key: 'details', align: 'left', label: '尺码明细' },
      { span: 2, key: 'actions', align: 'center', label: '操作', justify: 'flex-end' },
    ],
    mobile: [
      { span: 6, key: 'date', align: 'center', label: '日期' },
      { span: 6, key: 'style', label: '款式' },
      { span: 4, key: 'process', align: 'center', label: '工艺' },
      { span: 4, key: 'worker', align: 'center', label: '加工人' },
      { span: 4, key: 'details', label: '明细' },
    ],
  }

  // permission 模块单独处理
  result.permission = {
    systemViewPermission: { desktop: true, mobile: true, _permission: 'system_view_permission' },
    systemManagePermission: { desktop: true, mobile: false, _permission: 'system_manage_permission' },
    systemSwitchMode: { desktop: true, mobile: false, _permission: 'system_switch_mode' },
    columns: {
      desktop: [
        { span: 4, key: 'name', align: 'left', label: '名称' },
        { span: 16, key: 'permissions', align: 'left', label: '权限' },
        { span: 4, key: 'actions', align: 'center', label: '操作', justify: 'flex-end' },
      ],
      mobile: [
        { key: 'name', label: '名称' },
        { key: 'permissions', label: '权限' },
      ],
    },
  }

  result.other = {
    companyName: { desktop: true, mobile: false, _permission: null },
  }

  return result
})()

// ============================================================
// 3. 父级 → 子级权限映射
// ============================================================
export const PARENT_TO_CHILDREN_MAP = (() => {
  const map = {}
  for (const parent of PERMISSION_TREE) {
    map[parent.value] = parent.children.map(child => child.value)
  }
  return map
})()

// ============================================================
// 4. 子级 → 父级权限映射
// ============================================================
export const CHILD_TO_PARENT_MAP = (() => {
  const map = {}
  for (const parent of PERMISSION_TREE) {
    for (const child of parent.children) {
      map[child.value] = parent.value
    }
  }
  return map
})()

// ============================================================
// 5. 所有权限平铺数组
// ============================================================
export const ALL_PERMISSIONS = PERMISSION_TREE.flatMap(
  parent => parent.children.map(child => child.value)
)

// ============================================================
// 6. 权限标签映射
// ============================================================
export const PERMISSION_LABEL_MAP = (() => {
  const map = {}
  for (const parent of PERMISSION_TREE) {
    for (const child of parent.children) {
      map[child.value] = child.label
    }
  }
  return map
})()

// ============================================================
// 7. 按分类组织的权限
// ============================================================
export const PERMISSION_CATEGORIES = (() => {
  const result = {}
  for (const parent of PERMISSION_TREE) {
    const category = parent.label.replace(/^[^\s]+\s/, '')
    result[category] = parent.children.map(child => child.value)
  }
  return result
})()

// ============================================================
// 8. 开发环境校验
// ============================================================
if (import.meta.env?.MODE === 'development') {
  const allPermissionValues = new Set(ALL_PERMISSIONS)
  const errors = []

  for (const moduleFeatures of Object.values(FEATURES)) {
    for (const [key, config] of Object.entries(moduleFeatures)) {
      if (['columns', 'displayFields', 'card'].includes(key)) continue
      const perm = config._permission
      if (perm !== undefined && perm !== null && !allPermissionValues.has(perm)) {
        errors.push(`Feature "${key}" 引用了未定义的权限 "${perm}"`)
      }
    }
  }

  if (errors.length > 0) {
    console.warn('[deviceFeatures] ⚠️ 配置校验失败：', errors)
  }

  const allChildValues = Object.values(PARENT_TO_CHILDREN_MAP).flat()
  const missingChildren = ALL_PERMISSIONS.filter(p => !allChildValues.includes(p))
  if (missingChildren.length > 0) {
    console.warn(
      '[deviceFeatures] ⚠️ PARENT_TO_CHILDREN_MAP 中以下子权限缺失：',
      missingChildren
    )
  }
}

// ============================================================
// 9. 会员套餐权限配置
// ============================================================
export const PLAN_PERMISSIONS = {
  'basic': [
    'sale_view', 'sale_summary', 'sale_view_customer',
    'production_view', 'production_summary',
    'style_view',
    'process_view',
    'material_view',
    'customer_view',
    'bookkeeping_view', 'bookkeeping_summary',
  ],
  'pro': [
    'sale_view', 'sale_summary', 'sale_view_customer',
    'sale_add_date', 'sale_add_style', 'sale_add_size', 'sale_import', 'sale_import_from_production', 'sale_save',
    'sale_edit_size', 'sale_delete_row', 'sale_batch_delete', 'sale_settle', 'sale_screenshot', 'sale_toggle_color',
    'production_view', 'production_summary', 'production_analysis', 'production_edit_order_number', 'production_edit_customer',
    'production_add_date', 'production_add_style', 'production_add_size', 'production_edit_size',
    'production_delete_row', 'production_batch_delete', 'production_import', 'production_save',
    'production_assign_worker', 'production_update_status', 'production_screenshot', 'production_toggle_color',
    'production_settle',
    'bookkeeping_view', 'bookkeeping_summary',
    'bookkeeping_add_date', 'bookkeeping_add_style', 'bookkeeping_edit_entry', 'bookkeeping_settle',
    'bookkeeping_delete_row', 'bookkeeping_batch_delete', 'bookkeeping_screenshot',
    'style_view', 'style_add', 'style_edit', 'style_delete',
    'style_manage_category', 'style_manage_production_type', 'style_manage_process',
    'process_view', 'process_add', 'process_edit', 'process_delete', 'process_manage_type', 'process_manage_supplier',
    'material_view', 'material_add', 'material_edit', 'material_delete',
    'material_manage_supplier', 'material_manage_category',
    'customer_view', 'customer_add', 'customer_edit', 'customer_delete',
  ],
  'enterprise': [
    ...ALL_PERMISSIONS,
  ]
}

export function getPlanPermissions(planCode) {
  return PLAN_PERMISSIONS[planCode] || PLAN_PERMISSIONS['basic']
}

// ============================================================
// 10. 会员状态映射
// ============================================================
export const MEMBERSHIP_STATUS_MAP = {
  'active': { label: '✅ 有效', color: '#52c41a' },
  'expired': { label: '❌ 已过期', color: '#ff4d4f' },
  'trial': { label: '🆓 试用中', color: '#faad14' }
}

// ============================================================
// 11. 会员套餐映射
// ============================================================
export const MEMBERSHIP_PLAN_MAP = {
  'basic': '基础版',
  'pro': '专业版',
  'enterprise': '企业版',
  'trial': '试用版'
}

// ============================================================
// 12. 权限工具函数
// ============================================================
export function getChildrenPermissions(parentPerm) {
  return PARENT_TO_CHILDREN_MAP[parentPerm] || []
}

export function getParentPermission(childPerm) {
  return CHILD_TO_PARENT_MAP[childPerm] || null
}

export function hasChildren(parentPerm) {
  const children = PARENT_TO_CHILDREN_MAP[parentPerm]
  return children && children.length > 0
}

export function getEffectivePermissions(userPermissions) {
  const result = new Set(userPermissions || [])
  for (const perm of userPermissions || []) {
    const children = PARENT_TO_CHILDREN_MAP[perm] || []
    for (const child of children) {
      result.add(child)
    }
  }
  return Array.from(result)
}

export function getPermissionLabel(perm) {
  return PERMISSION_LABEL_MAP[perm] || perm
}

export function getPlanPermissionsByCategory(planCode) {
  const perms = getPlanPermissions(planCode)
  const result = {}
  for (const [category, keys] of Object.entries(PERMISSION_CATEGORIES)) {
    const matched = keys.filter(k => perms.includes(k)).map(k => getPermissionLabel(k))
    if (matched.length > 0) {
      result[category] = matched
    }
  }
  return result
}